module.exports = __webpack_public_path__ + "img/model_2.66dc3c3b.png";